// @flow

/**
 * The type of (redux) action to add known domains to the list of domains known
 * to the feature base/known-domains.
 *
 * {
 *     type: ADD_KNOWN_DOMAINS,
 *     knownDomains: Array<string>
 * }
 */
export const ADD_KNOWN_DOMAINS = 'ADD_KNOWN_DOMAINS';
